import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { generateValidationSchema } from "./Validations";
import { useFormik } from "formik";
import { Email } from "@mui/icons-material";
import { useInviteDocMutation } from "../State/Api/AdddocApiSlice";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { DatePicker } from "rsuite";
import ClinicTandCTable from "./ClinicTandCTable";

function UserManagement() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  const [invite, { isSuccess, isError, isLoading, error }] =
    useInviteDocMutation();

  const formFields = [
    "email",
    "Clinic_Hospital_Name",
    "Clinic_Hospital_ID",
    "Modules",
    "SubscriptionType",
    "SubscriptionStartDate",
    "SubscriptionEndDate",
  ];
  const validationSchema = generateValidationSchema(formFields);

  const Modules = [
    { name: "OPD", code: "OPD" },
    { name: "Pharmacy", code: "Pharmacy" },
    { name: "Ward Management", code: "Ward-Management" },
  ];

  const SubscriptionType = [
    { name: "Basic", code: "Basic" },
    { name: "Plus", code: "Plus" },
    { name: "Premium", code: "Premium" },
  ];

  const RoleTypeOptions = [
  { name: "Clinic", code: "Clinic" },
  { name: "Pharmacy", code: "Pharmacy" },
];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA");
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      Clinic_Hospital_Name: "",
      Clinic_Hospital_ID: "",
      RoleType: "",
      Modules: null,
      SubscriptionType: "",
      SubscriptionStartDate: "",
      SubscriptionEndDate: "",
      ISTrialVersion: true,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();

      formData.append("Email", values.email);
      formData.append("Clinic_Hospital_ID", values.Clinic_Hospital_ID);
      formData.append("Clinic_Hospital_Name", values.Clinic_Hospital_Name);
      formData.append("RoleName", values.RoleType);
      formData.append("Modules", values.Modules.join(","));
      formData.append("SubscriptionType", values.SubscriptionType);
      formData.append("SubscriptionStartDate", values.SubscriptionStartDate);
      formData.append("SubscriptionEndDate", values.SubscriptionEndDate);
      formData.append("ISTrialVersion", values.ISTrialVersion);
      try {
        if (formData) {
          const response = await invite(formData);

          if (
            response?.data?.result_Message ===
            "Email already invited but clinic/user info does not match."
          ) {
            alert("User already exists!");
            handleClose();
          } else {
            alert("Invited Successfully");
            resetForm();
            handleClose();
          }
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    },
  });


  const userStyles = `
  .p-dropdown-item-label {
   font-size: 14px;
  }
  
  `

  return (
    <>
    <style>{userStyles}</style>
    <main style={{ width: "100%", height: "100%" }}>
      <div className="row">
        <div className="col-12 mb-4 d-flex justify-content-between">
          <div className="d-flex">
            <h4 className="m-0 p-3">User Management</h4>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-3">
            <button
              className="div-ButtonGreen"
              variant="primary"
              onClick={handleShow}
            >
              + Invite User
            </button>
            <button
              className="div-ButtonGreen"
              onClick={() => navigate("/Registration")}
            >
              + Add User
            </button>
            <div className="d-flex align-items-center gap-3">
              <div className="position-relative div-okij8ijj">
                <input
                  type="text"
                  className="form-control div-TzEiOdMeYO"
                  placeholder="Search here"
                  style={{
                    padding: "0px 1.7rem 0px .5rem",
                    borderRadius: ".3rem",
                  }}
                />
                <div
                  className="position-absolute"
                  style={{ top: "10px", right: "8px" }}
                >
                  <button style={{ background: "none", border: "none" }}>
                    <i class="fa-solid fa-magnifying-glass"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ClinicTandCTable />
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "1rem", color: "#000000" }}>
            Invite Users
            <p style={{ fontSize: "0.7rem", color: "#000000" }}>
              invite users to join by highlighting benefits and providing a
              clear call to action.
            </p>
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="div-sxjsnjij9 mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Clinic / Hospital Name / Pharmacy Name
              </label>
              <input
                className="form-control"
                id="Clinic_Hospital_Name"
                name="Clinic_Hospital_Name"
                type="text"
                placeholder="User Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.Clinic_Hospital_Name}
                style={{
                  width: "100%",
                  height: "2.5rem",
                  cursor: "default",
                }}
              />
              {formik.touched.Clinic_Hospital_Name &&
              formik.errors.Clinic_Hospital_Name ? (
                <div
                  style={{ fontSize: "0.8rem", color: "red" }}
                  className="lbl-P9urEIgWf1"
                >
                  {formik.errors.Clinic_Hospital_Name}
                </div>
              ) : null}
            </div>

            <div className="div-sxjsnjij9 mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Clinic / Hospital ID / Pharmacy ID
              </label>
              <input
                className="form-control"
                id="Clinic_Hospital_ID"
                name="Clinic_Hospital_ID"
                type="text"
                placeholder="User ID"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.Clinic_Hospital_ID}
                style={{
                  width: "100%",
                  height: "2.5rem",
                  cursor: "default",
                }}
              />
              {formik.touched.Clinic_Hospital_ID &&
              formik.errors.Clinic_Hospital_ID ? (
                <div
                  style={{ fontSize: "0.8rem", color: "red" }}
                  className="lbl-P9urEIgWf1"
                >
                  {formik.errors.Clinic_Hospital_ID}
                </div>
              ) : null}
            </div>

            <div className="div-sxjsnjij9 mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Email Address
              </label>
              <input
                className="form-control"
                id="email"
                name="email"
                type="text"
                placeholder="Enter mail ID"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                style={{
                  width: "100%",
                  height: "2.5rem",
                  cursor: "default",
                }}
              />
              {formik.touched.email && formik.errors.email ? (
                <div
                  style={{ fontSize: "0.8rem", color: "red" }}
                  className="lbl-P9urEIgWf1"
                >
                  {formik.errors.email}
                </div>
              ) : null}
            </div>

            <div className="div-sxjsnjij9 mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Role Type
              </label>
              <Dropdown
                name="RoleType"
                value={formik.values.RoleType}
                onChange={(e) => formik.setFieldValue("RoleType", e.value)} // Formik integration [web:6][web:12]
                onBlur={() => formik.setFieldTouched("RoleType", true)}
                options={RoleTypeOptions}
                optionLabel="name"
                optionValue="code"
                placeholder="Select Role Type"
                className="w-full md:w-20rem multiselect-24px border"
              />
              {formik.touched.RoleType && formik.errors.RoleType && (
                <div
                  style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
                >
                  {formik.errors.RoleType}
                </div>
              )}
            </div>

            <div className="input-block mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Modules
              </label>
              <MultiSelect
                name="Modules"
                value={formik.values.Modules}
                onChange={(e) => formik.setFieldValue("Modules", e.value)}
                onBlur={formik.handleBlur}
                options={Modules}
                optionLabel="name"
                optionValue="name"
                placeholder="Select Modules"
                maxSelectedLabels={3}
                showSelectAll={false}
                className="w-full md:w-20rem multiselect-24px border"
              />
              {formik.touched.Modules && formik.errors.Modules && (
                <div
                  style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
                >
                  {formik.errors.Modules}
                </div>
              )}
            </div>
            <div className="input-block mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Subscription Type
              </label>
              <Dropdown
                name="Modules"
                value={formik.values.SubscriptionType}
                onChange={(e) =>
                  formik.setFieldValue("SubscriptionType", e.value)
                }
                onBlur={formik.handleBlur}
                options={SubscriptionType}
                optionLabel="name"
                optionValue="name"
                placeholder="Select Subscription Type"
                maxSelectedLabels={3}
                showSelectAll={false}
                className="w-full md:w-20rem multiselect-24px border"
              />
              {formik.touched.SubscriptionType &&
                formik.errors.SubscriptionType && (
                  <div
                    style={{
                      fontSize: "0.8rem",
                      color: "red",
                      marginTop: "3px",
                    }}
                  >
                    {formik.errors.SubscriptionType}
                  </div>
                )}
            </div>

            <div class="input-block mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Start Date
              </label>
              <DatePicker
                name="SubscriptionStartDate"
                value={
                  formik.values.SubscriptionStartDate
                    ? new Date(formik.values.SubscriptionStartDate)
                    : null
                }
                onChange={(value) =>
                  formik.setFieldValue(
                    "SubscriptionStartDate",
                    formatDate(value)
                  )
                }
                onBlur={() =>
                  formik.setFieldTouched("SubscriptionStartDate", true)
                }
                format="dd-MMM-yyyy"
                placeholder="dd-mmm-yyyy"
                placement="topEnd"
                oneTap
                style={{ width: "100%", height: "33px", borderRadius: "4px" }}
              />

              {formik.touched.SubscriptionStartDate &&
                formik.errors.SubscriptionStartDate && (
                  <div
                    style={{
                      fontSize: "0.8rem",
                      color: "red",
                      marginTop: "15px",
                    }}
                  >
                    {formik.errors.SubscriptionStartDate}
                  </div>
                )}
            </div>

            <div class="input-block mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                End Date
              </label>
              <DatePicker
                name="SubscriptionEndDate"
                value={
                  formik.values.SubscriptionEndDate
                    ? new Date(formik.values.SubscriptionEndDate)
                    : null
                }
                onChange={(value) =>
                  formik.setFieldValue("SubscriptionEndDate", formatDate(value))
                }
                onBlur={() =>
                  formik.setFieldTouched("SubscriptionEndDate", true)
                }
                format="dd-MMM-yyyy"
                placeholder="dd-mmm-yyyy"
                placement="topEnd"
                oneTap
                style={{ width: "100%", height: "33px", borderRadius: "4px" }}
              />

              {formik.touched.SubscriptionEndDate &&
                formik.errors.SubscriptionEndDate && (
                  <div
                    style={{
                      fontSize: "0.8rem",
                      color: "red",
                      marginTop: "15px",
                    }}
                  >
                    {formik.errors.SubscriptionEndDate}
                  </div>
                )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              className="border-0 rounded-2"
              style={{
                width: "100%",
                background: "#367588",
                color: "#fff",
                padding: ".5rem .5rem",
              }}
              type="submit"
            >
              Invite
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </main>
    </>
  );
}

export default UserManagement;
